import { inject, Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { EventComplete } from "./models/events/event-complete.model";
import { EventHostComplete } from "./models/event-hosts/event-host-complete.model";
import { UserBasic } from "./models/account/user-basic.model";
import { UserComplete } from "./models/account/user-complete.model";
import { ApiWrapperService } from "ngx-apiwrapper";
import { EventTicketComplete } from "./models/event-tickets/event-ticket-complete.model";
import { EventBasic } from "./models/events/event-basic.model";
import { EventCreation } from "./models/events/event-creation.model";
import { Organiser } from "./models/organisers/organiser.model";
import { EventBookingComplete } from "./models/event-bookings/event-booking-complete.model";

@Injectable({
  providedIn: 'root'
})
export class AdminService {
  private readonly _apiWrapper = inject(ApiWrapperService);

  // Events
  getEvents(): Observable<EventComplete[]> {
    return this._apiWrapper.get<EventComplete[]>(`admin/events`)
  }

  getArchivedEvents(): Observable<EventComplete[]> {
    return this._apiWrapper.get<EventComplete[]>(`admin/events/archive`)
  }
  
  getEvent(eventRef:string): Observable<EventComplete> {
    return this._apiWrapper.get<EventComplete>(`admin/events/${eventRef}`)
  }

  getEventHosts(): Observable<EventHostComplete[]> {
    return this._apiWrapper.get<EventHostComplete[]>('admin/event-hosts')
  }

  getEventHost(id: number): Observable<EventHostComplete> {
    return this._apiWrapper.get<EventHostComplete>('admin/event-hosts/' + id)
  }

  updateEvent(lrpEvent: EventComplete): Observable<EventComplete>{
    return this._apiWrapper.put(`admin/events/${lrpEvent.eventID}`,lrpEvent);
  }

  getUserPermissions() {
    return this._apiWrapper.get<UserBasic[]>('admin/users')
  }

  getUser(id:number) {
    return this._apiWrapper.get<UserComplete>('admin/users/' + id);
  }

  getPrivilegedUsers() {
    return this._apiWrapper.get<UserBasic[]>('admin/users/privileged')
  }

  updateEventTicket(ticket: EventTicketComplete) {
    return this._apiWrapper.put<EventTicketComplete>(`admin/events/${ticket.eventID}/tickets`,ticket)
  }
  createEventTicket(ticket: EventTicketComplete) {
    return this._apiWrapper.post<EventTicketComplete>(`admin/events/${ticket.eventID}/tickets`,ticket)
  }

  createEvent(lrpEvent: EventCreation){
    return this._apiWrapper.post<EventComplete>(`admin/events/`,lrpEvent)
  }

  getEventTicketTypes(): Observable<string[]> {
    return this._apiWrapper.get<string[]>(`admin/tickets`)
  }

  getOrganisers(): Observable<Organiser[]> {
    return this._apiWrapper.get<Organiser[]>('admin/organisers')
  }

  getEventBooking(eventId: number, bookingId: number): Observable<EventBookingComplete> {
    return this._apiWrapper.get<EventBookingComplete>(`admin/events/${eventId}/booking/${bookingId}`)
  }
}